/*
 * careers translations for the "ar" locale.
 *
 * Split out of locales/ar.js so this feature's copy stops shipping to
 * every route in the app. See locales/careers/index.js.
 */
export default {
  careers: {
    apply: "التقديم",
    section: "القسم",
    jobBrief: "معلومات الوظيفة",
    requirements: "المتطلبات",
    notHiring: "لا توجد وظائف متاحة في الوقت الحالي",
    jobs: [
      {
        id: 1,
        seo: {
          title: "وظيفة محاسب موردين | انضم لفريق كونتكت",
          meta_desc:
            ".وظيفة محاسب موردين في كونتكت المالية القابضة. انضم إلى فريقنا وساهم في نجاحنا. قدم الآن",
        },
        title: "محاسب موردين",
        section: "القطاع المالي",
        jobBrief: `<ul style="padding-right: 1.5rem;">
              <li style="margin-bottom:5px";>
                إدارة جميع المعاملات المحاسبية
              </li>
              <li style="margin-bottom:5px";>
                إعداد توقعات الميزانية والقوائم المالية في الوقت المناسب
              </li>
              <li style="margin-bottom:5px";>
                التعامل مع عمليات إغلاق الميزانية الشهرية والربع سنوية والسنوية
              </li>
              <li style="margin-bottom:5px";>
                تسوية الحسابات المستحقة للموردين
              </li>
              <li style="margin-bottom:5px";>
                ضمان المدفوعات المصرفية في الوقت المناسب
              </li>
              <li style="margin-bottom:5px";>
                حساب الضرائب وإعداد الإقرارات الضريبية
              </li>
              <li style="margin-bottom:5px";>
                إدارة الميزانيات العمومية وبيانات الأرباح والخسائر
              </li>
              <li style="margin-bottom:5px";>
                تقرير عن الصحة المالية للشركة وسيولتها
              </li>
              <li style="margin-bottom:5px";>
                المراجعة على البيانات و المعاملات والوثائق المالية
              </li>
              <li style="margin-bottom:5px";>
                المحافظة على سرية البيانات المالية وإجراء نسخ احتياطية من قاعدة
                البيانات عند الضرورة و الامتثال للسياسات والأنظمة المالية
              </li>
            </ul>`,
        requirements: ` <ul style="padding-right: 1.5rem;">
              <li style="margin-bottom:5px";>
                خبرة فى العمل كمحاسب موردين من عامين لخمسة أعوام
              </li>
              <li style="margin-bottom:5px";>
                معرفة ممتازة بالأنظمة والإجراءات المحاسبية
              </li>
              <li style="margin-bottom:5px";>
                اهتمام قوي بالتفاصيل والمهارات التحليلية الجيدة
              </li>
              <li style="margin-bottom:5px";>
                الحصول على درجة البكالوريوس في المحاسبة أو المالية أو درجة ذات
                صلة
              </li>
              <li style="margin-bottom:5px";>
                الشهادة (CPA أو CMA) هي ميزة إضافية
              </li>
            </ul>`,
      },
      {
        id: 2,
        title: "محاسب عملاء",
        seo: {
          title: "وظيفة محاسب عملاء | انضم لفريق كونتكت",
          meta_desc:
            "وظيفة محاسب عملاء في كونتكت المالية القابضة. انضم إلى فريقنا وساهم في نجاحنا. قدم الآن.",
          h2: "المسؤوليات الرئيسية",
        },

        section: "القطاع المالي",
        jobBrief: `     <ul style="padding-right: 1.5rem;">
                <li style="margin-bottom:5px";>
                  إدارة جميع المعاملات المحاسبية
                </li>
                <li style="margin-bottom:5px";>
                  إعداد توقعات الميزانية والقوائم المالية في الوقت المناسب
                </li>
                <li style="margin-bottom:5px";>
                  التعامل مع عمليات إغلاق الميزانية الشهرية والربع سنوية والسنوية
                </li>
                <li style="margin-bottom:5px";>
                  تسوية الحسابات المستحقة من العملاء
                </li>
                <li style="margin-bottom:5px";>
                  ضمان المدفوعات المصرفية في الوقت المناسب
                </li>
                <li style="margin-bottom:5px";>
                  حساب الضرائب وإعداد الإقرارات الضريبية
                </li>
                <li style="margin-bottom:5px";>
                  إدارة الميزانيات العمومية وبيانات الأرباح والخسائر
                </li>
                <li style="margin-bottom:5px";>
                  تقرير عن الصحة المالية للشركة وسيولتها
                </li>
                <li style="margin-bottom:5px";>
                  المراجعة على البيانات و المعاملات والوثائق المالية
                </li>
                <li style="margin-bottom:5px";>
                  المحافظة على سرية البيانات المالية وإجراء نسخ احتياطية من قاعدة
                  البيانات عند الضرورة و الامتثال للسياسات والأنظمة المالية
                </li>
              </ul>`,
        requirements: `        <ul style="padding-right: 1.5rem;">
                <li style="margin-bottom:5px";>
                  خبرة فى العمل كمحاسب عملاء من عامين لخمسة أعوام
                </li>
                <li style="margin-bottom:5px";>
                  معرفة ممتازة بالأنظمة والإجراءات المحاسبية
                </li>
                <li style="margin-bottom:5px";>
                  اهتمام قوي بالتفاصيل والمهارات التحليلية الجيدة
                </li>
                <li style="margin-bottom:5px";>
                  الحصول على درجة البكالوريوس في المحاسبة أو المالية أو درجة ذات
                  صلة
                </li>
                <li style="margin-bottom:5px";>
                  الشهادة (CPA أو CMA) هي ميزة إضافية
                </li>
              </ul>`,
      },
      {
        id: 3,
        seo: {
          title: "وظيفة مسؤول مبيعات | انضم لفريق كونتكت",
          meta_desc:
            ".وظيفة مسؤول مبيعات في كونتكت المالية القابضة. انضم إلى فريقنا وساهم في نجاحنا. قدم الآن",

          h2: "المسؤوليات الرئيسية",
        },
        title: "مسؤول مبيعات",
        section: "المبيعات",
        jobBrief: `     <ul style="padding-right: 1.5rem;">
              <li style="margin-bottom:5px";>
                بناء علاقات مع بائعي المنتجات والموردين والمحافظة عليها
              </li>
              <li style="margin-bottom:5px";>
                عرض برامج وأنظمة تقسيط مختلفة للعملاء
              </li>
              <li style="margin-bottom:5px";>
                توفير الدعم للعملاء منذ تقديم الطلب وحتى إتمام العملية البيعية
              </li>
              <li style="margin-bottom:5px";>
                ضمان سلاسة تجربة العملاء من خلال التنسيق مع الإدارات ذات الصلة
              </li>
            </ul>`,
        requirements: `      <ul style="padding-right: 1.5rem;">
              <li style="margin-bottom:5px";>مؤهل عالي </li>
              <li style="margin-bottom:5px";>
                0 - 3 سنوات من الخبرة في مجال المبيعات
              </li>
              <li style="margin-bottom:5px";>مهارات التواصل مع الأخرين</li>
              <li style="margin-bottom:5px";>
                القدرة على العمل تحت الضغط
              </li>
            </ul>`,
      },
    ],
  },
  jobs: {
    title: "وظائف",
    content:
      "مع النمو المستمر للشركة، نتطلع دائماً لإضافة المزيد من الكوادر البراقة لفريقنا الذي يضم أكثر من 2500 موظف. نتميز بمعدل مرتفع لاستمرارية موظفينا في العمل لفترات طويلة. حيث نؤمن بأهمية تنمية وتطوير كوادرنا البشرية من أجل تحقيق نمونا المنشود كأفراد وكفريق عمل وكمؤسسة. إن كنت ترغب في الانضمام إلينا يرجى ملء نموذج التقديم المرفق.",

    jobs_categories: [
      "الكل",
      "تكنولوجيا المعلومات",
      "التسويق",
      "المبيعات",
      "القطاع المالي",
    ],
  },
};
